import { needsMoneyWordsConfirm } from '../../lib/dollarsToWords.ts'
import { parseMoneyInput } from '../../lib/formatters.ts'
import { localDateKey } from '../../lib/localDate.ts'

export type BankConfirmMode = 'none' | 'readback' | 'voice-check'

/** Typed amounts are Save-confirmed. Voice ≥ $1,000 still needs the checkbox. */
export function bankConfirmMode(fromVoice: boolean, dollars: number): BankConfirmMode {
  if (!Number.isFinite(dollars)) return 'none'
  if (fromVoice && needsMoneyWordsConfirm(dollars)) return 'voice-check'
  return 'readback'
}

/** Save is visible in both states; enabled only for a non-negative amount and a real date. */
export function bankSaveEnabled(amountRaw: string, asOf: string): boolean {
  const dollars = parseMoneyInput(amountRaw)
  if (!Number.isFinite(dollars) || dollars < 0) return false
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(asOf || ''))) return false
  const [y, m, d] = String(asOf).split('-').map(Number)
  const dt = new Date(y, m - 1, d)
  if (dt.getFullYear() !== y || dt.getMonth() !== m - 1 || dt.getDate() !== d) return false
  return String(asOf) <= localDateKey()
}

/** Always today in America/Los_Angeles. Prior confirmation dates are never the default. */
export function bankAsOfDefault(_prior?: string | null): string {
  return localDateKey()
}

export function bankSaveLabel(asOf: string, today = localDateKey()): string {
  const key = String(asOf || '').slice(0, 10)
  if (key === today) return 'Save'
  const [y, m, d] = key.split('-').map(Number)
  if (!y || !m || !d) return 'Save'
  const label = new Date(y, m - 1, d).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  return `Save as of ${label}`
}
